// Live viewer tracking retired 2026-02. The hook is kept so existing
// call sites compile, but it's a complete no-op — no network requests,
// no intervals, nothing.

export function useLiveViewers() {
  return { viewers: 0, disabled: true };
}

export default useLiveViewers;
